import { Helmet } from 'react-helmet-async'

const SITE_NAME = 'My Mini Prints'
const BASE_URL = 'https://www.myminiprints.co.uk'
const DEFAULT_IMAGE = `${BASE_URL}/images/hand_foot_photo_white-pink.webp`

export default function PageMeta({ title, description, canonical, image = DEFAULT_IMAGE, noIndex = false, jsonLd = null }) {
    const fullTitle = title
        ? `${title} | ${SITE_NAME}`
        : `${SITE_NAME} | Baby Hand & Foot Casting Essex`
    const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : undefined

    return (
        <Helmet>
            <title>{fullTitle}</title>
            {description && <meta name="description" content={description} />}
            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
            {noIndex && <meta name="robots" content="noindex, nofollow" />}

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            {description && <meta property="og:description" content={description} />}
            {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
            <meta property="og:image" content={image} />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            {description && <meta name="twitter:description" content={description} />}
            <meta name="twitter:image" content={image} />
            {jsonLd && (
                <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
            )}
        </Helmet>
    )
}
